import { createSlice } from '@reduxjs/toolkit';
import { IUser, getUsers } from './actions';

export interface IUserState {
  users: IUser[];
  total: number;
  loading: boolean;
}

const initialState: IUserState = {
  users: [],
  total: 0,
  loading: true,
};

const MiraSleepUserSlider = createSlice({
  name: 'miraSleepUser',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // Get users
      .addCase(getUsers.pending, state => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.total = action.payload.metadata.total;
      })
      .addCase(getUsers.rejected, state => {
        state.loading = false;
      });

    // update user
    //   .addCase(updateCommunity.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(updateCommunity.fulfilled, (state) => {
    //     state.loading = false;
    //   })
    //   .addCase(updateCommunity.rejected, (state) => {
    //     state.loading = false;
    //   });
  },
});

export default MiraSleepUserSlider.reducer;
